var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { Box, Button, Link, LucidLinkLogo, translate } from '@lucidlink/uicore';
import { LUCID_LINK_OFFICIAL_WEBSITE, useAuthProvider, useLogOut, } from '@lucidlink/workspacemanagement';
export const MobileHeaderLayout = ({ children }) => {
    _react_refresh_temp_2();
    const navigate = useNavigate();
    const { currentUser } = useAuthProvider();
    const { mutation: { mutate: logOut }, } = useLogOut();
    /* The following block of code really hurts the eyes, but hopefully we do not need to extend anything
     * anymore in the mobile app. We need to hide the button in the register and verify email screens as
     * a 'register' button while on the register page doesn't make sense, and on verify email we already have a log out
     * button. */
    const isOnRegisterRoute = useMatch('register');
    const isOnVerifyEmail = useMatch('verify-email');
    const shouldShowHeaderButton = !isOnRegisterRoute && !isOnVerifyEmail;
    const isAuthenticated = Boolean(currentUser);
    const headerButtonOnClick = useCallback(() => {
        if (isAuthenticated) {
            logOut();
        }
        else {
            void navigate('/register');
        }
    }, [isAuthenticated, logOut, navigate]);
    return (_jsxs(Box, { "data-testid": "mobile-header-layout-container", gap: "sm", isFullWidth: true, orientation: "vertical", padding: "m l", children: [_jsxs(Box, { "data-testid": "mobile-header-layout-header-container", isFullWidth: true, justify: "between", children: [_jsx(Link, { "aria-label": translate('LucidLink official website'), "data-testid": "header-logo", to: LUCID_LINK_OFFICIAL_WEBSITE, children: _jsx(LucidLinkLogo, { alt: "", "data-testid": "mobile-header", height: 20, kind: "horizontal-colorful-white" }) }), shouldShowHeaderButton && (_jsx(Button, { "data-testid": "mobile-header", kind: "secondary", onClick: headerButtonOnClick, children: isAuthenticated
                            ? translate('Log out')
                            : translate('Register') }))] }), children] }));
};
_react_refresh_temp_1 = MobileHeaderLayout;
$RefreshReg$(_react_refresh_temp_1, "MobileHeaderLayout");
_react_refresh_temp_2(MobileHeaderLayout, "Lq9T9ceqNAoodLuu3ut9WLW8ljo=", false, () => [useNavigate, useAuthProvider, useLogOut, useMatch, useMatch]);
